import React from "react"
import styled from "@emotion/styled"

const Container = styled.header`
  background-color: #FF6961;
  padding: 10px;
  font-weight: bold;
  color: #FFFFFF;
`

const Text = styled.h1`
  font-size: 2.5rem;
  margin: 0;
  font-family: 'Josefin Sans', sans-serif;
  text-align: center;
`

const Header = ({titulo}) => {
    return (
        <Container>
            <Text>{titulo}</Text>
        </Container>
    )
}

export default Header